export default __webpack_public_path__ + "static/media/trustReportShare.c7627ddb.svg";